"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN_PROGRAM = void 0;
exports.TOKEN_PROGRAM = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA';